import { motion } from "framer-motion";

const ITEMS = [
  {
    n: "01",
    name: "NACHO BOX",
    desc: "Pastor or no meat, nacho cheese, sour cream, pinto beans, guacamole, jalapeños, olives & pico de gallo.",
    price: "$15",
    drink: "w/ drink $19",
    badge: "FEEDS 4-5",
  },
  {
    n: "02",
    name: "SMALL NACHO",
    desc: "Pastor or no meat, nacho cheese, sour cream, pinto beans, guacamole, jalapeños, olives & pico de gallo.",
    price: "$10",
    drink: "w/ drink $14",
  },
  {
    n: "03",
    name: "LOADED BAKED POTATOES",
    desc: "A hot baked potato piled high with all your favorite toppings.",
    price: "$15",
    drink: "w/ drink $19",
  },
  {
    n: "04",
    name: "FRIED TACOS",
    desc: "Golden, crispy tacos made fresh. Two tacos for $5.",
    price: "$5",
    drink: "w/ drink $9",
  },
];

const DRINKS = [
  { name: "Strawberry Lemonade", price: "$7" },
  { name: "Regular Lemonade", price: "$7" },
  { name: "Water", price: "$2" },
];

const LEMONADE_IMG =
  "https://images.unsplash.com/photo-1650092071863-b47da0c0065b?q=80&w=800&auto=format&fit=crop";

export default function MenuBoard() {
  return (
    <section id="menu" data-testid="menu-section" className="dots-bg-light relative overflow-hidden bg-tang py-20 lg:py-28">
      <div className="mx-auto max-w-5xl px-4 sm:px-6">
        <div className="mb-12 flex flex-wrap items-end justify-between gap-8">
          <div>
            <p className="text-sm font-black uppercase tracking-[0.24em] text-sunburst">Straight off the flyer</p>
            <h2 className="font-display mt-3 text-5xl font-bold uppercase text-white sm:text-6xl">
              Our Menu
              <svg viewBox="0 0 220 14" className="mt-1 h-3.5 w-52 text-sunburst" aria-hidden="true">
                <path d="M3 10 C 60 2, 160 2, 217 8" stroke="currentColor" strokeWidth="7" fill="none" strokeLinecap="round" />
              </svg>
            </h2>
          </div>
          <img
            src={LEMONADE_IMG}
            alt="Ice-cold strawberry lemonade"
            className="h-28 w-28 rotate-6 rounded-full border-4 border-ink object-cover shadow-pop sm:h-36 sm:w-36"
          />
        </div>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.1 }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="rotate-[-0.5deg] rounded-[2rem] border-4 border-ink bg-cream p-6 shadow-popXl sm:p-10"
        >
          <div className="space-y-9">
            {ITEMS.map((item) => (
              <article
                key={item.n}
                data-testid={`menu-item-${item.name.toLowerCase().replace(/\s+/g, "-")}`}
                className="relative flex flex-wrap items-start gap-4 sm:gap-6"
              >
                <span className="font-display flex h-12 w-12 shrink-0 items-center justify-center rounded-full border-[3px] border-ink bg-sunburst text-lg font-bold shadow-popSm">
                  {item.n}
                </span>
                <div className="min-w-[200px] flex-1">
                  <h3 className="font-display text-2xl font-bold uppercase tracking-wide text-tang sm:text-3xl">
                    {item.name}
                  </h3>
                  <p className="mt-1.5 max-w-xl text-sm font-semibold leading-relaxed text-ink/75 sm:text-base">
                    {item.desc}
                  </p>
                </div>
                <div className="flex w-24 flex-col items-end gap-1.5 pl-14 sm:w-40 sm:pl-0">
                  <p className="font-logo text-3xl text-tomato sm:text-4xl">{item.price}</p>
                  {item.drink && (
                    <span className="whitespace-nowrap rounded-full border-2 border-ink bg-sunburst px-3 py-1 text-xs font-black uppercase tracking-wide">
                      {item.drink}
                    </span>
                  )}
                </div>
                {item.badge && (
                  <span className="absolute -top-4 right-2 flex rotate-6 items-center rounded-full border-[3px] border-ink bg-tomato px-3 py-1 text-xs font-black uppercase tracking-wide text-white shadow-popSm sm:right-auto sm:left-[52%]">
                    {item.badge}
                  </span>
                )}
              </article>
            ))}
          </div>

          <div className="mt-10 border-t-[3px] border-dashed border-ink/25 pt-8">
            <div className="flex flex-wrap items-center justify-between gap-6">
              <div>
                <h3 className="font-display text-3xl font-bold uppercase text-tomato">Drinks</h3>
                <ul className="mt-3 space-y-1.5">
                  {DRINKS.map((d) => (
                    <li
                      key={d.name}
                      data-testid={`drink-item-${d.name.toLowerCase().replace(/\s+/g, "-")}`}
                      className="flex items-baseline gap-2 text-base font-bold text-ink/80"
                    >
                      {d.name}
                      <span className="flex-1 border-b-2 border-dotted border-ink/30" aria-hidden="true" />
                      <span className="font-logo text-xl text-tang">{d.price}</span>
                    </li>
                  ))}
                </ul>
              </div>
              <p className="max-w-xs rounded-2xl border-[3px] border-ink bg-white px-5 py-4 text-sm font-extrabold uppercase tracking-wide shadow-pop">
                Everything made fresh at your event
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
